





































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { isUserFriendlyEmail } from '@/tools/validators/emailValidators';

import { validationMixin } from 'vuelidate';
import UserDataMenuMixin from '@/mixins/userData';
@Component
export default class ComponentsEmailConfirm extends Mixins(
  UserDataMenuMixin,
  validationMixin
) {
  @Prop({ type: String, default: '' })
  readonly email!: string;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly padding!: boolean;

  disabledFlag = true;
  emailTimer: any = null;
  intervalTimer: any = null;
  interval: any = 30;

  getMessageByInsertedEmail(value: string) {
    const domain = value.replace(/.*@/, '');
    return domain;
  }
  validations() {
    const problemEmails =
      this.$store.state.regionProfile.constants.problem_email_domains;
    return {
      user: {
        profile: {
          email: {
            isUserFriendlyEmail: isUserFriendlyEmail(problemEmails),
          },
        },
      },
    };
  }

  get EmailService(): string {
    const { email } = this;
    return email ? `https://${email.split('@')[1]}` : '';
  }

  get isDisabled(): boolean {
    const { disabledFlag, emailTimer, intervalTimer } = this;
    return disabledFlag || (emailTimer && intervalTimer);
  }

  @Watch('disabled')
  isDisabledChanged(value: boolean) {
    if (value) this.setTimerEmail();
  }

  beforeMount() {
    const intervalTimer = localStorage.getItem('interval');
    this.disabledFlag = false;
    if (intervalTimer) {
      this.interval = intervalTimer;
      this.setTimerEmail(parseInt(`${intervalTimer}000`, 10));
    }
  }

  beforeDestroy() {
    this.clearCounters();
  }

  setLocalStorage() {
    localStorage.setItem('interval', this.interval);
  }

  setIntervalCount() {
    this.intervalTimer = setInterval(() => {
      this.interval--;
      this.setLocalStorage();
    }, 1000);
  }

  setTimerEmail(inteval = 30000) {
    this.setIntervalCount();
    this.setLocalStorage();
    this.emailTimer = setTimeout(() => {
      this.clearTimerEmail();
      this.$emit('clearDisabled');
    }, inteval);
  }

  clearTimerEmail() {
    this.clearCounters();
    this.emailTimer = null;
    this.intervalTimer = null;
    this.interval = 30;
    localStorage.removeItem('interval');
  }

  clearCounters() {
    const { emailTimer, intervalTimer } = this;
    if (emailTimer) clearTimeout(emailTimer);
    if (intervalTimer) clearInterval(intervalTimer);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/emailconfirm/Confirm.vue